import { CSSObject, Drawer, Theme } from "@mui/material"
import { styled } from "@mui/material/styles"

const drawerWidth = 200

const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: "hidden",
	// marginTop: '64px',
	boxShadow: "2px 0 5px rgba(0,0,0, 0.1)",
	backgroundColor: theme.palette.primary.main,

	color: theme.palette.primary.contrastText,
})

const closedMixin = (theme: Theme): CSSObject => ({
	width: `calc(${theme.spacing(6)} + 1px)`,
	[theme.breakpoints.up("sm")]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: "hidden",
	// marginTop: '64px',
	boxShadow: "2px 0 5px rgba(0,0,0, 0.1)",
	backgroundColor: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
})

const MenuDrawer = styled(Drawer, {
	shouldForwardProp: (properties) => properties !== "open",
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: "nowrap",
	MozBoxSizing: "border-box",
	...(open && {
		...openedMixin(theme),
		"& .MuiDrawer-paper": openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		"& .MuiDrawer-paper": closedMixin(theme),
	}),
}))

export default MenuDrawer
